
async function handleJsonResponse(res) {
  let data = null;

  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    const message =
      data?.detail ||
      data?.message ||
      data?.error ||
      "Failed to submit intake.";
    throw new Error(message);
  }

  return data;
}
export async function getUnknownExercises() {
  const res = await fetch("/py/unknown-exercises", {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return handleJsonResponse(res);
}

export async function checkUnknownExercise(unknownId) {
  const res = await fetch(`/py/unknown-exercises/${unknownId}/check`, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return handleJsonResponse(res);
}